import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form/Form.types";
import { IUiSchema } from "@rentiohq/shared-frontend/dist/forms/forms.types";
import {
  contactSelectInlineV2ValueSelector,
  getValue,
} from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { IPartialRootState } from "@rentiohq/shared-frontend/dist/redux/types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { JSONSchema6 } from "json-schema";
import { EField } from "./schema.linkContact.types";

export const getSchema =
  (initialValues: { [key: string]: any }) =>
  (defaultValues: { [key: string]: any }): JSONSchema6 => {
    return {
      required: [EField.Contact],
      properties: {
        [EField.Contact]: {
          default: getValue(EField.Contact, initialValues, defaultValues),
        },
      },
    };
  };

export const uiSchema = (): IUiSchema<EField> => ({
  "rentio:navigationTitle": getLocalizedText("form.link_contact"),
  [EField.Contact]: {
    "ui:field": ERentioFormField.ContactSelectInlineV2,
    isMultiSelect: false,
    title: getLocalizedText("form.link_contact.existing_contact.label"),
    valueSelector: (
      state: IPartialRootState,
      selectedAccountIds: number[] | string = [],
    ) => {
      return contactSelectInlineV2ValueSelector(state, selectedAccountIds);
    },
    customGetSubtitleSelector: () => undefined,
    customExtraAccountsSelector: () => [],
    customIsFetchingSelector: () => false,
    customGetContactsActions: [],
    ignoreSelf: true,
    allowCreate: false,
    customFilter: {
      where: {
        and: [
          { type: { eq: null } },
          { inviteAcceptedAt: { eq: null } },
          { duplicateWithoutConnection: { neq: true } },
        ],
      },
    },
  },
});
